<template>
<v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="80%"
          persistent>
  <v-card class="d-flex flex-column">
    <v-card-title class="primary white--text">
      {{getTitle}}
      <v-spacer/>
      <v-btn text elevation="0" color="white" small @click="cancelar">
        Fechar <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text ref="scrollBody" class="py-4 flex-grow-1" 
      style="height: 80%;"
      v-if="value">

      <SejaBemVindoCadastreSe v-if="!concorda" @onEscolha="opcaoPoliticaPrivacidade"/>

      <v-form v-if="concorda" ref="form" @submit.prevent="save" v-model="formValid" lazy-validation>
        <CompradorForm v-model="item"/>
      </v-form>

    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="success" @click="cancelar" :disabled="loading">Cancelar</v-btn>
      <v-btn color="primary" @click="save" :disabled="!formValid || !concorda || loading">Salvar</v-btn>
    </v-card-actions>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>  
</v-dialog>
</template>

<script>
import CompradorForm from "../../components/shared/forms/CompradorForm";
import SejaBemVindoCadastreSe from "../../components/shared/common/SejaBemVindoCadastreSe";
import {cadastreSe} from "../../api/comprador";
import {ApiError} from "../../api/core";

export default {
  name: "CadastreSeCompradorDialog",
  components: {CompradorForm, SejaBemVindoCadastreSe},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    titulo: {
      type: String,
      default: "",
    }
  },
  data () {
    return {
      formValid: false,
      loading: false,
      concorda: false,
    }
  },
  computed: {
    getTitle() {
      return this.titulo;
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.resetScrollTop();
      }
    },
    concorda(val) {
      if (val) {
        this.resetScrollTop();
      }
    }
  },
  methods: {
    resetScrollTop() {
      this.$nextTick(() => {
        if (this.$refs.scrollBody && typeof this.$refs.scrollBody.scrollTo === 'function') {
          this.$refs.scrollBody.scrollTo({ top: 0, behavior: 'auto' });
        } else if (this.$refs.scrollBody) {
          this.$refs.scrollBody.scrollTop = 0;
        }
      });
    },
    async save() {
      try {
        this.loading = true;
        if (!this.item.contatos.length) {
          this.$toast.error('É necessário adicionar pelo menos um responsável.', {
            timeout: 6000
          })
          return;
        }        
        if(this.$refs.form.validate()) {
          this.item.contatosParaCadastro = this.item.contatos.map(item => Object.values(item).join("(-)")).join("(;)");
          const retornoCadastreSe = await cadastreSe(this.item);
          const observacaoInscricaoEventos = `
            <div style="margin-top: 16px; padding: 12px 14px; border-left: 4px solid #167ABC; background: #eef6fd; border-radius: 6px;">
              <strong style="display: block; margin-bottom: 4px; color: #167ABC;">Atenção</strong>
              <span>Caso o cadastro tenha sido realizado pela tela de eventos, você será direcionado para a lista de eventos disponíveis, onde poderá selecionar a opção desejada e concluir sua inscrição.</span>
            </div>
          `;
          this.$swal({
            title: 'Sucesso',
            html: `${retornoCadastreSe.msg}${observacaoInscricaoEventos}`,
            icon: 'success',
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,          
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
              const credenciais = {
                tipoConta: 'comprador',
                login: this.item.contatos[0].email,
                password: this.item.contatos[0].senha,
              };
              this.$emit('onCancela', 'login', credenciais);
              this.cancelar();
            }
          });
        }
      } catch (err) {
        let menssagemErro = '';
        if (err instanceof ApiError) {
          menssagemErro = this.formattedMessageAlert(err.message);
        } else {
          menssagemErro = `Ocorreu algum erro ao se cadastrar. Entre em contato com o suporte!`;
        }
        this.$swal({
          title: 'Ocorreu um erro',
          html: menssagemErro,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok'
        });
      } finally {
        this.loading = false;
      }
    },
    opcaoPoliticaPrivacidade(opcao){
      if(opcao === 'S'){
        this.concorda = true;
      } else {
          this.$emit('input', false);
      }
    },
    cancelar() {
      this.concorda = false;
      this.item.id = null;
      this.item.idAtividadeEconomica = null;
      this.item.descricaoAtividadeEconomica = "";
      this.item.nomeFantasia = "";
      this.item.razaoSocial = "";
      this.item.descricao = "";
      this.item.cnpj = "";
      this.item.senha = "";
      this.item.endereco = "";
      this.item.bairro = "";
      this.item.complemento = "";
      this.item.cidade = "";
      this.item.estado = "";
      this.item.cep = "";
      this.item.telefone = "";
      this.item.email = "";
      this.item.siteRede = "";
      this.item.contatos = [];
      this.item.contatosParaCadastro = ""; 
      this.$emit('input', false);
    }
  },
  mounted() {
    this.cancelar();
  },
}
</script>

<style scoped>

</style>